import { Routes } from '@angular/router';

import { InfluencerAddComponent } from './influencer-add';
import { InfluencerListComponent } from './influencer-list';

import { AuthGuard }                  from '@app/_guards';
import { NonInfluencerGuard } from '@app/_guards/non-influencer.guard';

export const INFLUENCER_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: 'add',
        component: InfluencerAddComponent
      },
      {
        path: '',
        component: InfluencerListComponent
      },
      {
        path: 'view/:influencerId',
        component: InfluencerAddComponent
      },
      {
        path: 'edit/:influencerId',
        component: InfluencerAddComponent
      }
    ],
    canActivate: [AuthGuard, NonInfluencerGuard]
  }
];
